import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./apiClient";

export const useDataQueueCountQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['data-queue/count'],
    queryFn: async () => {
      const res = await apiClient.get('/data-queue/count');
      if (!res?.data.payload) return {};
      return res.data.payload.reduce((acc, item) => {
        if (!acc[item.buildingId]) acc[item.buildingId] = { count: 0, consumptionCount: 0, invoiceCount: 0 };
        acc[item.buildingId].count += item.count;
        if (item.type === 'consumption') acc[item.buildingId].consumptionCount += item.count;
        if (item.type === 'invoice') acc[item.buildingId].invoiceCount += item.count;
        return acc;
      }, {} as Record<string, {count: number, consumptionCount: number, invoiceCount: number}>);
    },
    enabled
  });
}